// The sqlite adapter is not needed in the browser, IndexedDB is used instead.
export default function SQLiteAdapterFactory() {
  return { __webNoop: true };
}
